import { type WorkspaceAgentSelectAssetSourceKey } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/select-asset/workspaceAgentSelectAssetTypes';
import { WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY } from '~/components/v2/components/workspace/workspace-agent-panel/mentions/workspaceAgentMentionSources';

export type GetWorkspaceAgentSelectAssetEmptyCopyParams = {
  hasFailed: boolean;
  isBoardPickerOpen: boolean;
  query: string;
  source: WorkspaceAgentSelectAssetSourceKey;
};

export const getWorkspaceAgentSelectAssetEmptyCopy = ({
  hasFailed,
  isBoardPickerOpen,
  query,
  source,
}: GetWorkspaceAgentSelectAssetEmptyCopyParams): string => {
  if (hasFailed) {
    if (isBoardPickerOpen) {
      return WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY.boards.errorStateMessage;
    }

    return source === 'brand-kit'
      ? WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY['brand-kit'].errorStateMessage
      : WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY.assets.errorStateMessage;
  }

  if (isBoardPickerOpen) {
    return query === ''
      ? WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY.boards.noItemsMessage
      : WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY.boards.emptyStateMessage;
  }

  if (source === 'board') {
    return query === ''
      ? WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY.assets.noItemsMessage
      : WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY.assets.emptyStateMessage;
  }

  return query === ''
    ? WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY['brand-kit'].noItemsMessage
    : WORKSPACE_AGENT_MENTION_SOURCES_BY_KEY['brand-kit'].emptyStateMessage;
};
